<template>
  <router-view v-if="isRouterAlive"></router-view>
</template>

<script>
import { nextTick, provide,ref } from 'vue';

export default {
  name: 'App',
  components: {

  },
  setup() {
    const isRouterAlive = ref(true)
    const reload = () => {
      isRouterAlive.value = false
      nextTick(() => { isRouterAlive.value = true})
    }
    provide('reload',reload)
    return {
        isRouterAlive,
        reload
      }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  margin: 0;
  padding: 0;
}
</style>
